import { generateNumberMask } from 'components/modules/Insurance/Insurance.helpers';
import { VALUE_FIELDS } from 'store/carInstance/constants';

export const ENGINE_VOLUME_MASK = generateNumberMask({
  min: 0.1,
  mapToRadix: [',', '.'],
  max: 10 ** 2,
  postfix: 'л',
  radix: '.',
  scale: 3,
});

export const NAME = VALUE_FIELDS.ENGINE_VOLUME;
